/**
 * The scope a parameter editor is pinned to (TP-FR-009).
 *
 * Kept in its own module so the resolution helpers and the editor can both
 * import it without importing each other.
 */
export type EditorTarget =
  | { scope: 'global' }
  | { scope: 'profile'; profileId: string; profileName: string }
  | {
      scope: 'terminal';
      terminalId: string;
      terminalLabel: string;
      profileId: string | null;
      profileName: string | null;
    };

/** The `scopeId` the API expects for a target. `*` for global (TP-FR-003). */
export function targetScopeId(target: EditorTarget): string {
  switch (target.scope) {
    case 'global':
      return '*';
    case 'profile':
      return target.profileId;
    case 'terminal':
      return target.terminalId;
  }
}
